import {Component, HostListener, Inject, OnInit, QueryList, Renderer2, ViewChildren, DOCUMENT} from '@angular/core';
import {PaintingCathegoryService} from '../service/paintingCathegory.service';
import {Router} from '@angular/router';
import {EventNumberService} from '../service/eventNumber.service';

import {UpcomingEventService} from '../service/upcomingEvent.service';
import { TranslateService } from '@ngx-translate/core';
import {LanguageService} from '../service/language.service';
import { AfterViewInit, ElementRef, ViewChild } from '@angular/core';
@Component({
    selector: 'app-home',
    templateUrl: './home.component.html',
    styleUrls: ['./home.component.scss'],
    standalone: false
})
export class HomeComponent implements OnInit, AfterViewInit {
  @ViewChildren('lazyElement', { read: ElementRef }) lazyElements!: QueryList<ElementRef>;



  // tslint:disable-next-line:variable-name max-line-length
  constructor(@Inject(DOCUMENT) private document: Document, private _paintingCathegory: PaintingCathegoryService,
              // tslint:disable-next-line:variable-name
              private _eventNumber: EventNumberService, private router: Router, private _upcomingEvents: UpcomingEventService,
              // tslint:disable-next-line:variable-name
              private renderer: Renderer2, private translate: TranslateService, private _language: LanguageService) {
    this._language.current_lang.subscribe(lang => {
      if (lang === 0 ) {
        translate.use('ro');
      } else {
        translate.use('en');
      }
    });
  }
  redirectToMarketplaceLogin(): void {
    this.router.navigate(['Login']);
  }
  redirectToGallery(): void {
    this.router.navigate(['Gallery']);
  }
  goToPaintingDetails(category: string, id: string): void {
    this.router.navigate(['Painting/' + category + '/' + id]);
  }
  goToCategory(categoryId: string): void {
    localStorage.setItem('homeCategoryId', categoryId);
    this.redirectToGallery();
  }
  // tslint:disable-next-line:use-lifecycle-interface
  ngAfterViewInit(): void {
    // tslint:disable-next-line:no-shadowed-variable
    const observer = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
          observer.unobserve(entry.target); // Stop observing once it's visible
        }
      });
    }, { threshold: 0.1 }); // Trigger when 10% of the element is visible

    // Observe each lazy-load element
    this.lazyElements.forEach(element => observer.observe(element.nativeElement));
  }

  ngOnInit(): void {
  }
}
